import { defineSelectorResultFunction } from '@exodus/redux-dependency-injection';
const DEFAULT = Object.create(null);
const resultFunction = (rates, currency) => rates[currency] ?? DEFAULT;
const fiatRatesSelector = defineSelectorResultFunction({
    id: 'fiatRates',
    resultFunction,
    dependencies: [
        //
        { selector: 'data' },
        { module: 'locale', selector: 'currency' },
    ],
});
export default fiatRatesSelector;
